<script setup lang="ts">
const consent = ref<'yes' | 'no' | null>(null)

useSeoMeta({
  title: 'Contact Us — TARC LTD CO',
  description: 'Get in touch with TARC LTD CO.',
  robots: 'noindex',
})
</script>

<template>
  <UContainer class="py-16 max-w-2xl">
    <UPageHeader
      title="Contact Us"
      description="Fill out the form below and we'll get back to you."
    />
    <UPageBody>
      <UForm :state="{ consent }" class="space-y-6">
        <UFormField label="Name" required>
          <UInput placeholder="Your name" class="w-full" />
        </UFormField>

        <UFormField label="Email" required>
          <UInput type="email" placeholder="you@example.com" class="w-full" />
        </UFormField>

        <UFormField label="Phone Number" required>
          <UInput type="tel" placeholder="+1 (555) 000-0000" class="w-full" />
        </UFormField>

        <UFormField label="Message">
          <UTextarea placeholder="How can we help?" class="w-full" :rows="4" />
        </UFormField>

        <div class="rounded-lg border border-default bg-elevated/50 p-4 space-y-3 text-sm text-muted">
          <p>
            TARC LTD CO would like your consent to send informational text message communications
            from <strong>+18444902220</strong> to your mobile number listed above, in response to
            your questions or to provide information relevant to your relationship with us.
          </p>
          <p>
            Consent is not a condition of purchase. Message frequency varies. Message and data rates
            may apply. Reply <strong>STOP</strong> to unsubscribe at any time. Reply
            <strong>HELP</strong> for assistance or more information. We do not share your mobile
            opt-in information with anyone. See our
            <NuxtLink to="/privacy-policy" class="underline">privacy policy and messaging terms and conditions</NuxtLink>
            for more information.
          </p>
        </div>

        <UFormField label="Text message consent" required>
          <div class="space-y-2">
            <label class="flex items-start gap-3 cursor-pointer">
              <input
                v-model="consent"
                type="radio"
                value="yes"
                class="mt-0.5 accent-primary"
              />
              <span class="text-sm">Yes, I consent to receive informational messages from TARC LTD CO.</span>
            </label>
            <label class="flex items-start gap-3 cursor-pointer">
              <input
                v-model="consent"
                type="radio"
                value="no"
                class="mt-0.5 accent-primary"
              />
              <span class="text-sm">No, I do not want to receive any text messages from TARC LTD CO.</span>
            </label>
          </div>
        </UFormField>

        <UButton type="submit" size="lg">
          Send Message
        </UButton>
      </UForm>
    </UPageBody>
  </UContainer>
</template>
